import { AgentRoute } from "../components/diagnosticAgent/util/agentRoutes";
import { removeTrailingSlash } from "fe-common/routes/removeTrailingSlash";
import {
  getCurrentEnumRoute,
  getRouteRegex,
} from "fe-common/routes/commonPathUtils";

/***
 * Remove "/" at end of path variables to easier make url manipulations
 * @param path a url string either ending with "/" or not
 * @return the url string without a "/" at the end
 */

/***
 * Remove last route ex: "/url/to/route/" will return "/url/to"
 * @param path a url string either ending with "/" or not
 */
export function removeLastRoute(path: string) {
  return removeTrailingSlash(
    path.substr(0, removeTrailingSlash(path).lastIndexOf("/")),
  );
}

/***
 * Return the path proceeding a known agent route
 * (since some routes my act like :/agent/expanded/(:id)/(:?acion)) etc this code will return
 * /agent
 * @param path
 */
export function removeLastAgentRoute(path: string) {
  const currentRoute = getCurrentAgentRoute(path);
  if (!currentRoute) return removeTrailingSlash(path);

  const regex = getRouteRegex(currentRoute);
  const routeIndex = regex.exec(path).index;
  return removeTrailingSlash(path.substr(0, routeIndex));
}

export function getCurrentAgentRoute(path: string): AgentRoute {
  return getCurrentEnumRoute(path, AgentRoute) as AgentRoute;
}

export function getPathParams(path: string): string[] {
  return path.split("/");
}
